if (!customElements.get('custom-made-proof-slider')) {
  class CustomMadeProofSlider extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-proof-track]');

      if (!this.track) return;

      this.abortController = new AbortController();
      const { signal } = this.abortController;

      this.track.addEventListener('scroll', () => this.updateOverflowState(), { signal, passive: true });
      this.resizeObserver = new ResizeObserver(() => this.updateOverflowState());
      this.resizeObserver.observe(this.track);

      this.track.addEventListener('pointerdown', (event) => this.startDrag(event), { signal });
      this.track.addEventListener('pointermove', (event) => this.drag(event), { signal });
      this.track.addEventListener('pointerup', () => this.stopDrag(), { signal });
      this.track.addEventListener('pointercancel', () => this.stopDrag(), { signal });
      this.track.addEventListener('keydown', (event) => this.handleKeydown(event), { signal });

      this.updateOverflowState();
      this.classList.add('is-ready');
    }

    disconnectedCallback() {
      this.abortController?.abort();
      this.resizeObserver?.disconnect();
    }

    getStep() {
      const card = this.track.querySelector('.custom-made-proof__media, .custom-made-proof__placeholder');
      if (!card) return 0;

      const gap = Number.parseFloat(window.getComputedStyle(this.track).columnGap) || 0;
      return card.getBoundingClientRect().width + gap;
    }

    startDrag(event) {
      if (event.pointerType !== 'mouse' || event.button !== 0) return;
      if (event.target instanceof Element && event.target.closest('video, a, button, input')) return;

      this.dragStartX = event.clientX;
      this.dragStartScroll = this.track.scrollLeft;
      this.isDragging = true;
      this.track.classList.add('is-dragging');
      this.track.setPointerCapture(event.pointerId);
    }

    drag(event) {
      if (!this.isDragging) return;

      this.track.scrollLeft = this.dragStartScroll - (event.clientX - this.dragStartX);
    }

    stopDrag() {
      if (!this.isDragging) return;

      this.isDragging = false;
      this.track.classList.remove('is-dragging');
    }

    updateOverflowState() {
      const maxScroll = this.track.scrollWidth - this.track.clientWidth;
      const hasPrevious = maxScroll > 2 && this.track.scrollLeft > 2;
      const hasNext = maxScroll > 2 && this.track.scrollLeft < maxScroll - 2;

      this.classList.toggle('has-prev', hasPrevious);
      this.classList.toggle('has-next', hasNext);
    }

    handleKeydown(event) {
      if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;

      const step = this.getStep();
      if (!step) return;

      event.preventDefault();
      this.track.scrollBy({ left: event.key === 'ArrowLeft' ? -step : step, behavior: 'smooth' });
    }
  }

  customElements.define('custom-made-proof-slider', CustomMadeProofSlider);
}
